$(function() {

  var swiper = new Swiper('.mySwiperImages', {
		// grabCursor: true,
		effect: "creative",
		loop: true,
		autoplay: {
			delay: 4000,
		},
		speed: 1000,
		// autoplay: 4000,
		allowTouchMove: true,
		creativeEffect: {
			prev: {
				shadow: true,
				opacity: '0.9',
				translate: ["0%", 0, -1],
			},
			next: {
				opacity: '0.2',
				translate: ["100%", 0, 0],
			},
		},
    //   breakpoints: {
    //   490: {
    //     allowTouchMove: false,
    //   },
    // },
	});


	var swiper2 = new Swiper('.mySwiperInfo', {
		// grabCursor: true,
		direction: "vertical",
		// effect: "slide",
		effect: "creative",
		//autoHeight: true,
		// autoplay: {
		// 	delay: 5000,
		// },
		loop: true, // Not recommended to enable!!!
		allowTouchMove: true,
		creativeEffect: {
			prev: {
				shadow: true,
				translate: [0, "-10%", -1],
			},
			next: {
				opacity: '0',
				translate: [0, "100%", 0],
			},
      // breakpoints: {
      //   490: {
      //     allowTouchMove: false,
      //   },
      // },
		},
		// on: {
    //   slideChangeTransitionStart: function () {
    //       // Slide captions
    //       var swiper = this;
    //       setTimeout(function () {
    //         var currentTitle = $(swiper.slides[swiper.activeIndex]).attr("data-title");
    //         var currentSubtitle = $(swiper.slides[swiper.activeIndex]).attr("data-subtitle");
    //       }, 500);
    //       gsap.to($(".current-title"), 0.4, {autoAlpha: 0, y: -40, ease: Power1.easeIn});
    //       gsap.to($(".current-subtitle"), 0.4, {autoAlpha: 0, y: -40, delay: 0.15, ease: Power1.easeIn});
    //   },
    //   slideChangeTransitionEnd: function () {
    //   		// Slide captions
    //       var swiper = this;
    //       var currentTitle = $(swiper.slides[swiper.activeIndex]).attr("data-title");
    //       var currentSubtitle = $(swiper.slides[swiper.activeIndex]).attr("data-subtitle");
    //       $(".slide-captions").html(function() {
    //         return "<h2 class='current-title'>" + currentTitle + "</h2>" + "<h3 class='current-subtitle'>" + currentSubtitle + "</h3>";
    //       });
    //       gsap.from($(".current-title"), 0.4, {autoAlpha: 0, y: 40, ease: Power1.easeOut});
    //       gsap.from($(".current-subtitle"), 0.4, {autoAlpha: 0, y: 40, delay: 0.15, ease: Power1.easeOut});
    //   }
    // }
	});

	swiper.controller.control = swiper2;
	swiper2.controller.control = swiper;


// Slide captions
// var currentTitle = $(mySwiper.slides[mySwiper.activeIndex]).attr("data-title");
// var currentSubtitle = $(mySwiper.slides[mySwiper.activeIndex]).attr("data-subtitle");
// $(".slide-captions").html(function() {
//   return "<h2 class='current-title'>" + currentTitle + "</h2>" + "<h3 class='current-subtitle'>" + currentSubtitle + "</h3>";
// });


	// swiper.on('slideChange', function (s) {
	// 	console.log('slide changed');
	// 	console.log('index 1 - ', swiper.activeIndex);
	// 	swiper2.slideTo(swiper.activeIndex);
	// });

	// swiper2.on('slideChange', function (s) {
	// 	console.log('slide 2 changed 2');
	// 	console.log('index 2', swiper2.activeIndex);
	// 	swiper.slideTo(swiper2.activeIndex);
	// });



	// var quoteSwiper = new Swiper('.mySwiperInfo', {
	// 	direction: "vertical",
	// 	effect: "slide",
	// 	//autoHeight: true,
	// 	loop: true, // Not recommended to enable!!!
	// 	allowTouchMove: true,
	// });
	// quoteSwiper.controller.control = this.imageSwiper;

	// var $Speed = 1000;

	// var imageSwiper = new Swiper('.mySwiperImages', {
	// 	mousewheel: true,
	// 	speed: $Speed,
	// 	loop: true, // Not recommended to enable!!!
	// 	longSwipesRatio: 0.01,
	// 	followFinger: false,
	// 	grabCursor: true, 
	// 	watchSlidesProgress: true,
	// 	parallax: true,
	// 	effect: "creative",
	// 	creativeEffect: {
	// 		prev: {
	// 			shadow: true,
	// 			translate: ["-20%", 0, -1],
	// 		},
	// 		next: {
	// 			translate: ["100%", 0, 0],
	// 		},
	// 	},
	// 	lazy: {
	// 		loadPrevNext: true,
	// 	},
	// });

	// imageSwiper.controller.control = this.quoteSwiper;


	// var swiper3 = new Swiper(".mySwiperImages", {
	// 	grabCursor: true,
	// 	effect: "creative",
	// 	loop: true,
	// 	creativeEffect: {
	// 		prev: {
	// 			shadow: true,
	// 			translate: ["-20%", 0, -1],
	// 		},
	// 		next: {
	// 			translate: ["100%", 0, 0],
	// 		},
	// 	},
	// });


	var dirRtlFlag = false;
	if ($("html").attr('dir') == 'rtl') {
		dirRtlFlag = true;
	}

	$('#hp-banners').slick({
		dots: false,
		infinite: true,
		speed: 1000,
		fade: true,
		rtl: dirRtlFlag,
		arrows: false,
		autoplay: true,
		autoplay: false,
		autoplaySpeed: 3000,
		cssEase: 'linear',
		pauseOnHover: false
	});

	$(window).scroll(function() {
		var x = $(this).scrollTop(); /* scroll pos */
		var y = $("html").height();
		var z = x / y;

		curTop = (((z * 800) + 0));
		$("#banners-scroll").css("top", (curTop + 0) + "px");
	});

	// var hasWebRTC = navigator.getUserMedia ||
	//                 navigator.webkitGetUserMedia ||
	//                 navigator.mozGetUserMedia ||
	//                 navigator.msGetUserMedia;

	// if (!hasWebRTC) {
	//   $('.wrap-banner-scroll').css('position','static');
	// }

	// Get IE or Edge browser version
	var version = detectIE();

	// if (version === false) {
	//   document.getElementById('result').innerHTML = '<s>IE/Edge</s>';
	// } else if (version >= 12) {
	//   document.getElementById('result').innerHTML = 'Edge ' + version;
	// } else {
	//   document.getElementById('result').innerHTML = 'IE ' + version;
	// }

	// add details to debug result
	// document.getElementById('details').innerHTML = window.navigator.userAgent;

	/**
	 * detect IE
	 * returns version of IE or false, if browser is not Internet Explorer
	 */
	function detectIE() {
		var ua = window.navigator.userAgent;

		var msie = ua.indexOf('MSIE ');
		if (msie > 0) {
			// IE 10 or older => return version number
			return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
		}

		var trident = ua.indexOf('Trident/');
		if (trident > 0) {
			// IE 11 => return version number
			var rv = ua.indexOf('rv:');
			return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
		}
		// var edge = ua.indexOf('Edg/');
		// if (edge > 0) {
		//   // Edge (IE 12+) => return version number
		//   // console.log(ua.substring(edge + 4, ua.indexOf('.', edge)));
		//   return parseInt(ua.substring(edge + 4, ua.indexOf('.', edge)), 10);
		// }

		//  var Firefox = ua.indexOf('Firefox/');
		// if (Firefox > 0) {
		//   return parseInt(ua.substring(Firefox + 8, ua.indexOf('.', Firefox)), 10);
		// }

		// other browser
		return false;
	}

	if (version) {
		$('.wrap-banner-scroll').css('position', 'static');
	} else {

	}

});